import React from 'react'
import Confetti from 'react-confetti'
import { Icons } from '../../components/ui';

function Home () {
  return (
    <div className="fade-in min-h-screen bg-gradient-to-b from-brand-50/60 to-white flex items-center justify-center px-4 py-12">
      <Confetti opacity="0.7" friction="0.95 " />
      <div className="relative z-10 w-full max-w-xl bg-white border border-gray-200 rounded-2xl shadow-card p-10 text-center">
        <div className="w-14 h-14 rounded-full bg-brand-50 border border-brand-100 text-brand-600 grid place-items-center mx-auto">
          <Icons.Check className="w-7 h-7" />
        </div>
        <h2 className="mt-5 text-xl sm:text-2xl font-bold text-slate-900">
          Congratulations! You are successfully registered for the event!
        </h2>
        <p className="mt-3 text-slate-500 max-w-md mx-auto leading-relaxed">
          Standby for a message from us on WhatsApp with your Pictures.
        </p>
      </div>
    </div>
  )
}

export default Home;
